import CaptureTravelDocuments from './CaptureTravelDocuments';
import { withRouter } from 'react-router';
import { withUser } from '../../../components/queries/GetUserQuery';

export default withRouter(withUser(CaptureTravelDocuments));
